//handles different displays for data snapshot fields
export enum SnapshotDisplayMode {
  Normal = 0, //question: answer
  Grid = 1, //column header with values under
  MultiInput = 2, //question with multiple answers or multiple sub questions
  Documents = 3, //document list. This will render document list at the end of the snapshot
  NestedDocuments = 4, //document list nested inside of a collection. This will render document list wherever it exists inside of the snapshot collection
  CalloutContent = 5, //callout content
  GridTwoColumn = 6, //column header with one value (2 column)
}
